import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { queryCache, useMutation, } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { setUserItem } from '../operations/setItem';
export function useWebStorageSetUserItem(storageKey, update) {
    var _this = this;
    var _a;
    var queryKey = ['WebStorage', storageKey];
    var identity = (_a = useIdentity()) === null || _a === void 0 ? void 0 : _a.data;
    return useMutation(function (vars) { return __awaiter(_this, void 0, void 0, function () {
        var previousValue, newValue;
        return __generator(this, function (_a) {
            queryCache.cancelQueries(queryKey);
            previousValue = queryCache.getQueryData(queryKey);
            newValue = update(previousValue, vars);
            if (newValue) {
                queryCache.setQueryData(queryKey, newValue);
                setUserItem(identity.puid, storageKey, newValue);
                Promise.resolve(newValue);
            }
            Promise.reject('Invalid value');
            return [2 /*return*/];
        });
    }); }, {
        onError: function (_err, _vars, snapshot) {
            queryCache.setQueryData(queryKey, snapshot);
        },
    });
}
//# sourceMappingURL=useWebStorageSetUserItem.js.map